<template>
  <div class="card shadow" v-on:click="onClick(course.id)">
    <div class="triangle-topleft"></div>
    <div class="dateOverImage">
      <b>{{ course.startDate }}</b>
    </div>
    <img :src="require(`@/assets/images/${course.imageName}`)" />
    <div class="container">
      <h4>
        <b>{{ course.title }}</b>
      </h4>
      <p>{{ course.description }}</p>
    </div>
  </div>
</template>

<script>
import router from '@/Router.vue';

export default {
  setup() {},

  props: {
    course: Object,
  },
  methods: {
    onClick(id) {
      router.push(`/course/${id}`);
    },
  },
};
</script>

<style scoped>
.card {
  transition: 0.3s;
  width: 350px;
  margin: 20px;
  background-color: whitesmoke;
  position: relative;
}

.dateOverImage {
  position: absolute;
  top: 0;
  margin: 10px;
}
.triangle-topleft {
  position: absolute;
  top: 0;
  width: 60px;
  height: 0;
  border-top: 40px solid whitesmoke;
  border-right: 50px solid transparent;
}

img {
  width: 100%;
  height: 400px;
  object-fit: cover;
  transition: 0.3s;
  size: 1;
}

.card:hover {
  width: 370px;
  margin: 0px;
}

.container {
  padding: 2px 16px;
}
</style>
